<template>
  <v-container fluid>
    <v-row align="center" justify="center">
      <v-col class="mt-12" cols="12" sm="10" md="8" lg="6" xl="4">
        <h2 class="text-h4 font-weight-bold">Frequently Asked Questions</h2>
        <div class="mt-12">
          <div class="mb-12">
            <ul class="text-body-2">
              <li v-for="(faq, index) in faqs" :key="index">
                <a :href="`#${faq.uid}`" :title="faq.data.faq_title[0].text">
                  {{ faq.data.faq_title[0].text }}
                </a>
              </li>
            </ul>
          </div>

          <div
            v-for="(faq, index) in faqs"
            :id="faq.uid"
            :key="index"
            class="mb-12 anchor"
          >
            <prismic-rich-text
              :field="faq.data.faq_title"
              :html-serializer="faqTitleSerializer"
            />
            <prismic-rich-text :field="faq.data.faq_content" />
          </div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import prismicDOM from 'prismic-dom'
import { mapState } from 'vuex'

const Elements = prismicDOM.RichText.Elements
const faqTitleSerializer = function(type, element, content, children) {
  if (type === Elements.heading3) {
    return `<h3 class="title font-weight-bold mb-2">${children.join('')}</h3>`
  }
  return null
}

export default {
  data() {
    return {
      faqTitleSerializer
    }
  },
  head({ $seo }) {
    return $seo({
      title: 'Frequently Asked Questions',
      description: 'The answers to your questions. Understand how the photography website 100ASA works.'
    })
  },
  computed: {
    ...mapState({
      faqs: state => state.faq.list
    })
  },
  async mounted() {
    if (this.$store.state.faq.list.length === 0) {
      try {
        this.loading = true
        await this.$store.dispatch('faq/getFaqs')
        const fullPath = this.$route.fullPath
        const hasHash = fullPath.includes('#')
        if (hasHash && 'scrollBehavior' in document.documentElement.style) {
          const hash = fullPath.split('#')[1]
          const el = document.getElementById(hash)
          window.scrollTo({
            top: el.getBoundingClientRect().top
          })
        }
      } catch (error) {
        this.$asa.appInsights('Pages: faq.vue - method: mounted', error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.anchor::before {
  display: block;
  content: ' ';
  margin-top: -64px;
  height: 64px;
  visibility: hidden;
  pointer-events: none;
}
</style>
